var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "chartContainer",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "250px",
      "overflow": "hidden",
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChartCanvas && !_vm.displayAsJson && _vm.hasValidData,
      expression: "showChartCanvas && !displayAsJson && hasValidData"
    }],
    ref: "chartCanvas",
    staticClass: "chart-canvas",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }), !_vm.hasValidData && !_vm.displayAsJson ? _c('div', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-1 text--disabled"
  }, [_vm._v(_vm._s(_vm.$t('Dashboards.noDataAvailableForTimeRange')))])]) : _vm._e(), _vm.displayAsJson ? _c('json-viewer', {
    attrs: {
      "value": _vm.chartOptionsJson
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };